export { default } from './ReviewStars'
